import Vue from 'vue'
import Vuex from 'vuex'
import WorkCenterInfo from './modules/work-center-info'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    workCenterInfo: WorkCenterInfo
  }
})
